import { makeStyles } from '@material-ui/core/styles'
import greenTick from 'src/assets/Buy_Policy_Images/greenTick.svg'
import roundCross from 'src/assets/Buy_Policy_Images/roundCross.svg'
import { Box } from '@mui/material'

const BikeComparison = () => {
  const classes = useStyles()

  return (
    <Box className={classes.comparisonContainer}>
      <Box className={classes.comparisonTypeRow}>
        <Box className={classes.comparisonPoints}>
          <Box className={classes.comparisonTitle}>Comparison</Box>
          <Box className={classes.comparisonText}>
            Damages to your bike due to accidents
          </Box>
          <Box className={classes.comparisonText}>
            Damages to your bike due to natural or man-made disasters
          </Box>
          <Box className={classes.comparisonText}>
            Damages to your bike in case of accidental fire/explosion
          </Box>
          <Box className={classes.comparisonText}>Theft of your Bike</Box>
          <Box className={classes.comparisonText}>
            Damages to a Third-party Vehicle/ Property
          </Box>
          <Box className={classes.comparisonText}>
            Injuries or Death of a Third-Party individual
          </Box>
        </Box>
        <Box className={classes.thirdPartyType}>
          <Box className={classes.thirdPartyTitle}>Third-Party</Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
        </Box>
        <Box className={classes.comprehensiveType}>
          <Box className={classes.comprehensiveTitle}>Comprehensive*</Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
        </Box>
        <Box className={classes.ownDamageType}>
          <Box className={classes.ownDamageTitle}>Own Damage**</Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={greenTick} alt='tick' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
          <Box className={classes.imageDiv}>
            <img src={roundCross} alt='cross' />
          </Box>
        </Box>
      </Box>
      <Box className={classes.mandatoryText}>*Mandatory by law</Box>
      <Box className={classes.optText}>
        **You can opt for an own damage cover if you have only an active
        third-party cover
      </Box>
    </Box>
  )
}

export default BikeComparison

const useStyles = makeStyles({
  comparisonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    backgroundColor: '#FFFFFF',
    paddingTop: 6,
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 30,
    fontFamily: 'Roboto',
  },
  comparisonTypeRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    justifyContent: 'space-between',
  },
  comparisonPoints: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '300px',
    maxHeight: '700px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
  },
  thirdPartyType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '160px',
    maxHeight: '700px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      ' linear-gradient(180deg, #EF669B -80.32%, rgba(255, 255, 255, 0) 85.09%)',
  },
  comprehensiveType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '160px',
    maxHeight: '700px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      ' linear-gradient(180deg, #4DC3E3 -80.32%, rgba(255, 255, 255, 0) 85.09%)',
  },
  ownDamageType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '160px',
    maxHeight: '700px',
    padding: '30px',
    border: '1px',
    borderRadius: '10px',
    background:
      'linear-gradient(180deg, #9271BE -80.32%, rgba(255, 255, 255, 0) 85.09%)',
  },
  comparisonTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
  },
  thirdPartyTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#E25B8F',
  },
  comprehensiveTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#3092AD',
  },
  ownDamageTitle: {
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '23px',
    color: '#8561B5',
  },
  comparisonText: {
    fontSize: '18px',
    lineHeight: '27px',
    padding: '10px',
    textAlign: 'right',
    marginLeft: 'auto',
    color: '#525252',
  },
  imageDiv: { padding: '20px' },
  mandatoryText: { color: '#3092AD' },
  optText: { color: '#8561B5', marginTop: '-10px' },
})
